import { type EnergyAudit } from 'interfaces/EnergyAudit.interface';
import RenderBlocks from '../lists/BulletBlockList';
import { type FC } from 'react';

interface EnergyAuditBenefitsTabProps {
  data: EnergyAudit;
}

const EnergyAuditBenefitsTab: FC<EnergyAuditBenefitsTabProps> = ({ data }) => {
  const tabData = (data as any).benefits;
  const blocks = tabData?.blocks;
  const isPeakLoadImpacted = data.is_peak_load_impacted;
  const peakLoadImpactBlocks = (data as any).peak_load_impact?.blocks;

  return (
    <div className="flex flex-col gap-6">
      <RenderBlocks blocks={blocks} />
      {isPeakLoadImpacted &&
        Array.isArray(peakLoadImpactBlocks) &&
        peakLoadImpactBlocks.length > 0 && (
          <>
            <div className="h-px w-full bg-primary/20" />
            <div>
              <h3 className="text-base font-semibold mb-1">Peak Load Impact</h3>
              <RenderBlocks blocks={peakLoadImpactBlocks} />
            </div>
          </>
        )}
    </div>
  );
};

export default EnergyAuditBenefitsTab;
